export const RAW_APPROVAL_REQUEST = "RAW_APPROVAL_REQUEST";
export const RAW_APPROVAL_SUCCESS = "RAW_APPROVAL_SUCCESS";
export const RAW_APPROVAL_FAILED = "RAW_APPROVAL_FAILED";
